import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import {getValidToken, getValidTokenKiosk} from '../../services/getValidToken';

import {invalidateUser} from '../../reducers/userReducer';
import * as modal from '../../reducers/modalReducer';
import * as userReducer from '../../reducers/userReducer';
import {hideViewDetail} from '../../actions/product';
import {showScrollView} from '../../actions/view';
import {
  setDeliveryAddresses,
  setPickupAddresses,
  setDeliveryById,
  setPickupById,
  reset
} from '../../reducers/addressReducer';
import {closedUrls, kioskMode as kioskModeUriValue} from '../../config/uri';
import {fetchByCategory, fetchCategories, setCurrentCategoryIndex} from '../../actions/api';
import {showProduct} from '../../actions/product';
import {getProfile} from '../../actions/signup-async';
import {isCategory, isItem} from '../../helpers/urlParts';
import {getCategoryNames} from '../../reducers/configReducer';
import {
  isDelivery, 
  isPaymentKiosk as isPaymentKioskSelector
} from '../../selectors/configSelectors';
import {getKioskModeUri} from '../../services/mode';
import {useKioskCustomer} from "../../actions/login";
import { getProductsBySelectedCustomerType } from '../../selectors/product_selector';
import {paymentKioskHub} from '../../services/paymentKiosk';
import { getProducts } from '../../selectors/product_selector';
import { isUserFetchedSelector } from '../../selectors/userSelectors';
import { pushWithQueryParams } from '../../services/uri';

class Redirector extends Component {
  componentDidMount() {
    this.checkLegacyMenuRedirect();
    this.getProfile();

    if (this.props.isKioskMode) {
      this.props.history.listen(this.onKioskModeRouteChange.bind(this));
    }
  }

  checkLegacyMenuRedirect() {
    // Fallback check for legacy menu redirect in case bootstrap didn't catch it
    const { config } = this.props;
    if (config && config.LEGACY_MENU_REDIRECT_URL && config.LEGACY_MENU_REDIRECT_URL.trim() !== '') {
      const redirectUrl = config.LEGACY_MENU_REDIRECT_URL;
      const currentSearch = window.location.search;

      const finalRedirectUrl = currentSearch
        ? `${redirectUrl}${redirectUrl.includes('?') ? '&' : '?'}${currentSearch.substring(1)}`
        : redirectUrl;

      window.location.href = finalRedirectUrl;
    }
  }

  onKioskModeRouteChange(route) {
    // replace route to route with '/kiosk' mark	    // replace route to route with '/kioskMode' mark
    if (this.props.isKioskMode && (route.pathname.indexOf(this.props.kioskMode) < 0)) {
      this.props.history.replace({pathname: this.replaceUrlToKioskMode(route.pathname)});
    }
  }	  

  replaceUrlToKioskMode(path) {
    const kioskMode = getKioskModeUri(this.props.kioskMode);
    return path
      .replace(process.env.PUBLIC_URL, kioskMode)
      .replace(/\/$/, '');
  }

  isUserPresent = () => {
    const {
      user,
    } = this.props;
    return user && user.tokens.token && user.id && (!user.tempUser || Object.values(user.tempUser).length === 0);
  }

  getProfile = () => {
    const {
      user,
      getProfile,
      setUser,
      isDelivery,
      setDeliveryAddresses,
      resetDelivery,
      setDeliveryById,
      setPickupById,
      fetchCategories
    } = this.props;
    if (this.isUserPresent()) {
      getProfile().then(
        res => {
          const data = res.data;
          // set user data
          setUser({
            firstName: data.firstName,
            lastName: data.lastName,
            isID: data.dl,
            isRec: data.rec,
            isMisc: data.misc,
            rewardPoints: data.rewardPoints,
            rewardTier: data.rewardTier,
            redemeedPoints: data.redemeedPoints,
            adult: data.adult,
            id: data.id,
            customerType: data.customerType,
            isFetched: true
          });

          fetchCategories();

          // set delivery addresses
          const deliveryAddresses = data.addresses.map(addr => {
            return {address: addr};
          });

          if (isDelivery) {
            setDeliveryAddresses(deliveryAddresses);
          } else {
            resetDelivery();
          }
          // set pickup addresses
          // this.props.setPickupAddresses(data.pickupAddresses)
          // set primary address
          if (data.deliveryDetail.type === 'DELIVERY' && isDelivery) {
            setDeliveryById(data.deliveryDetail.addressId);
          } else {
            setPickupById(data.deliveryDetail.addressId);
          }

        }
      );
    }

  }

  redirectToPage() {
    const {
      router,
      fetchByCategory,
      allowedCategories,
      fetchAllByCategory,
      products,
      showProduct
    } = this.props;
    const path = router.pathname;

    const id = path.substr(path.lastIndexOf('/') + 1);
    if (isCategory(path) && allowedCategories.indexOf(id.toUpperCase()) !== -1 && !isItem(path)) {
      fetchByCategory(id.toUpperCase());
    } else if (isItem(path)) {
      // get category name
      const categoryPath = path.substr(path.indexOf('/category'));
      const categoryArray = categoryPath.split('/');
      const categoryName = categoryArray[2];
      const categoryItem = categoryArray[4];
      // fetch products by category
      fetchAllByCategory(categoryName).then(
        () => {
          const data = products.data;
          let productIndex;
          data.some((item, index) => {
            if (item.categoryId === categoryItem) {
              productIndex = index;
              return true;
            }
            return false;
          });
          // redirect user to product in that category
          showProduct(productIndex);
        }
      );
    }
  }

  async checkRoute(targetRoute) {
    // check if route in array of closed routes
    let closed = false;
    closedUrls.forEach(item => {
      if (targetRoute.indexOf(item) === 0) closed = true;
    });
    if (closed) {
      const {isPaymentKiosk} = this.props;
      if (isPaymentKiosk) {
        this.props.useKioskCustomer();
        return;
      }
      const token = await getValidToken();
      if (!token) {
        this.props.toMain();
        this.props.invalidate();
        this.props.openLoginForm();
      }
    }
  }

  render() {
    if (this.isUserPresent() && !this.props.isUserFetched) {
      return <div></div>;
    }
    return (
      <div>{this.props.children}</div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    router: state.router.location,
    user: state.user,
    config: state.config,
    products: getProducts(state),
    isDelivery: isDelivery(state),
    allowedCategories: getCategoryNames(state),
    isDposMode: state.view.isDposMode,
    isMainBoardMode: state.view.isMainBoard,
    isSelfServiceMode: state.view.isSelfServiceMode,
    isKioskMode: state.view.isKioskMode,
    kioskMode: state.view.kioskMode,
    isPaymentKiosk: isPaymentKioskSelector(state),
    isUserFetched: isUserFetchedSelector(state)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toMain: () => dispatch(pushWithQueryParams('/')),
    invalidate: () => dispatch(invalidateUser()),
    openLoginForm: () => dispatch(modal.openModal({
      modalType: 'LOGIN_FORM',
      modalProps: {
          raisedClass: 'raise'
      }
    })),
    setCurrentCatIdx: (index) => dispatch(setCurrentCategoryIndex(index)),
    fetchByCategory: (name) => dispatch(fetchByCategory(name, 0, 20)),
    go: (path) => dispatch(pushWithQueryParams(path)),
    // TODO change hardcoded number with flag to fetch all
    fetchAllByCategory: (name) => dispatch(fetchByCategory(name, 0, 100)),
    showProduct: (index) => dispatch(showProduct(index)),
    getProfile: () => getProfile(),
    setUser: (user) => dispatch(userReducer.setUser(user)),
    setDeliveryAddresses: (addresses) => dispatch(setDeliveryAddresses(addresses)),
    setPickupAddresses: (addresses) => dispatch(setPickupAddresses(addresses)),
    setDeliveryById: (id) => dispatch(setDeliveryById(id)),
    setPickupById: (addressId) => dispatch(setPickupById(addressId)),
    hideViewDetail: () => dispatch(hideViewDetail()),
    showScrollView: () => dispatch(showScrollView()),
    resetDelivery: () => dispatch(reset()),
    useKioskCustomer: () => {
      dispatch(useKioskCustomer());
    },
    fetchCategories: () => dispatch(fetchCategories()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Redirector));



// WEBPACK FOOTER //
// ./src/components/Redirector/Redirector.js